import { useContext } from 'react';
import styles from './PageProductCallToActionRenewPrice.module.css';
import useSearchParamOrDefaultProps from '../hooks/useSearchParamOrDefaultProps.js';
import ProductsContext from '../contexts/ProductsContext.js';
import classNames from 'classnames';
import PropTypes from 'prop-types';

function PageProductCallToActionRenewPrice({ outlineColor, margin }) {
  const {
    showCallToActionPrice,
    showCallToActionPriceIntervalCount,
    showCallToActionPriceIntervalCountVerbose,
    // offerGroup
    productSku: productProp,
  } = useSearchParamOrDefaultProps();

  const products = useContext(ProductsContext);

  const product = products[productProp];
  const { rate_plans: ratePlans } = product;
  const [{ prices }] = ratePlans;

  // Discount may not always exist but when it does it takes precedence
  // from a UI perspective and is the primary offer to display.
  const [originalRatePlan, discountRatePlan = {}] = prices.sort(
    ({ amount_usd: aAmountUSD }, { amount_usd: bAmountUSD }) =>
      bAmountUSD - aAmountUSD,
  );

  const {
    amount_usd: originalRatePlanAmountUSD,
    interval: originalRatePlanInterval,
    interval_count: originalRatePlanIntervalCount,
  } = originalRatePlan;
  const {
    amount_usd: discountRatePlanAmountUSD,
    interval: discountRatePlanInterval,
    interval_count: discountRatePlanIntervalCount,
  } = discountRatePlan;

  const ratePlanCurrency = '$';

  // Discounts take precedence over original rate plan values
  const targetRatePlanIntervalCount =
    discountRatePlanIntervalCount || originalRatePlanIntervalCount;
  const targetRatePlanInterval =
    discountRatePlanInterval || originalRatePlanInterval;
  const targetRatePlanAmountUSD =
    discountRatePlanAmountUSD || originalRatePlanAmountUSD;

  return (
    <div
      style={{ '--PageProductRenewPrice__outlineColor': outlineColor, margin }}
      className={styles.PageProductRenewPrice}
    >
      <div className={styles.PageProductRenewPriceHeader}>
        {`${targetRatePlanIntervalCount} ${targetRatePlanInterval} offer`.toUpperCase()}
      </div>
      <div className={styles.PageProductRenewPriceDetails}>
        <span>
          {showCallToActionPrice === 'true' ? 'UPGRADE FOR' : 'UPGRADE'}
        </span>
        {showCallToActionPrice === 'true' && (
          <span className={styles.PageProductRenewPriceDetailsInterval}>
            {discountRatePlanAmountUSD && (
              <s
                className={styles.strikethrough}
              >{`${ratePlanCurrency}${originalRatePlanAmountUSD}`}</s>
            )}
            <span
              className={classNames(styles.price, {
                [styles.priceWithoutStrikethroughShown]:
                  typeof discountRatePlanAmountUSD === 'undefined',
              })}
            >
              {`${ratePlanCurrency}${targetRatePlanAmountUSD}`}
            </span>
            {showCallToActionPriceIntervalCount === 'true' &&
              showCallToActionPriceIntervalCountVerbose === 'true' && (
                <span className={styles.interval}>
                  /{targetRatePlanInterval}
                </span>
              )}
          </span>
        )}
      </div>
    </div>
  );
}

PageProductCallToActionRenewPrice.propTypes = {
  outlineColor: PropTypes.string,
  margin: PropTypes.string,
};

export default PageProductCallToActionRenewPrice;
